import { WebshopUtils } from '../../shared/webshop/webshop-utils';
import { EpressProduct, ProductTypes } from '@dch/products-business-logic';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import {
  ApplicationState,
  getProductDetailsPending,
  getProductDetailsTechnicalError,
  getSelectedProductDetails,
} from 'src/app/store/reducers';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';
import { GetProductDetails } from '../../store/actions/product-details.actions';
import { getPiiServiceId } from '../../shared/pii/pii.utils';
import { ActivatedRoute, Router } from '@angular/router';
import { InceptionService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-epress',
  templateUrl: './epress.component.html',
  styleUrls: ['./epress.component.css'],
})
export class EpressComponent extends OnDestroyHookDirective implements OnInit {
  ePressProductDetails: EpressProduct;

  private ePressChange = new Subject<any>();
  ePressChange$ = this.ePressChange.asObservable();
  hasError = false;
  isPending = false;

  constructor(
    private store: Store<ApplicationState>,
    private route: ActivatedRoute,
    private inceptionService: InceptionService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    setTimeout(() => {
      const serviceId = getPiiServiceId();
      if (serviceId) {
        this.addSubscription(
          this.store
            .select(getSelectedProductDetails)
            .subscribe((productDetails) => {
              if (productDetails && productDetails.ePressProductDetails) {
                this.ePressProductDetails = productDetails.ePressProductDetails;
                WebshopUtils.publishCartRetrival(
                  this.ePressProductDetails.installationId,
                  this.ePressProductDetails.accessNumber,
                  this.ePressProductDetails.plc,
                );
              }
            }),
        );

        this.addSubscription(
          this.route.params.subscribe((params) => {
            this.store.dispatch(
              new GetProductDetails({
                productType: ProductTypes.EPRESS.toString(),
                serviceId,
              }),
            );
          }),
        );

        this.addSubscription(
          this.store
            .select(getProductDetailsTechnicalError)
            .subscribe((value) => {
              this.hasError = value !== null;
            }),
        );

        this.addSubscription(
          this.store.select(getProductDetailsPending).subscribe((pending) => {
            this.isPending = pending;
          }),
        );

        this.scrollToTop();
      } else {
        this.router.navigate(['/overview']);
      }
    }, 50);
  }

  onEpressSwapChange() {
    this.ePressChange.next();
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#ePressDetails');
    });
  }
}
